import { render } from "./TrendChartWaitTime.vue?vue&type=template&id=25ee03ca&scoped=true"
import script from "./TrendChartWaitTime.vue?vue&type=script&lang=js"
export * from "./TrendChartWaitTime.vue?vue&type=script&lang=js"

import "./TrendChartWaitTime.vue?vue&type=style&index=0&id=25ee03ca&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ee03ca"]])

export default __exports__